import "./Chips.css";

export interface ChipsProps {
  chips: string[];
}

function Chips({ chips }: ChipsProps) {
  return (
    <div className="chip-row">
      {chips.map((chip, index) => (
        <span key={`${chip}-${index}`} className="chip">
          {chip}
        </span>
      ))}
    </div>
  );
}

export default Chips;
